import { SPAN_SCOPE } from './spanScope';

export const SPAN_SCOPE_METRICS_ATTRIBUTES = {
    [SPAN_SCOPE.REPORT_SCOPE]: ['reportId', 'dateRange', 'accountType', 'isHeavyAccount'],
};
